import React, { useState } from 'react';


const CommunityChat = () => {
  const [textMessage, setTextMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [communityUsers] = useState([
    { id: 101, username: 'CommunityUser1' },
    { id: 102, username: 'CommunityUser2' },
    { id: 103, username: 'CommunityUser3' },
  ]);

  const sendTextMessage = () => {
    if (!textMessage) return;

    const newMessage = {
      id: messages.length + 1,
      senderId: 1,
      text: textMessage,
    };

    setMessages([...messages, newMessage]);
    setTextMessage('');

    // In a real application, you should send the message to your server using an API call here
    // Example: sendTextMessageToCommunity(textMessage);
  };

  return (
    <div className="community-chat-container">
      <div className="message-display">
        <h2>Community Chat</h2>
        <div className="message-list">
          {messages.map((message) => (
            <div key={message.id} className="message received">
              <div className="message-container">{message.text}</div>
            </div>
          ))}
        </div>
        <div className="message-input">
          <input
            type="text"
            placeholder="Type your message to the community..."
            value={textMessage}
            onChange={(e) => setTextMessage(e.target.value)}
          />
          <button onClick={sendTextMessage}>Send</button>
        </div>
      </div>
    </div>
  );
};

export default CommunityChat;
